import React, {FC, useState} from "react"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Card, {CardProps} from "@irati/ui/src/Layout/Card"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import SubscribeModal from "./SubscriptionModal"
import ConfirmationModal from "./ConfirmationModal"
import {Icon, Circle} from "./styled"

const modalStates = ["none", "subscribe", "complete"] as const
type ModalState = typeof modalStates[number]

interface Props extends CardProps, InjectIntl {
  children?: never
  trackingSource: string;
}

const SubscriptionBanner: FC<Props> = ({children, formatMessage, trackingSource, ...rest}) => {
  const {colors} = useTheme()
  const [modalState, setModalState] = useState<ModalState>("none")

  return (
    <>
      <Card bgColor={colors.primary1_50} as="article" {...rest}>
        <Flex gap={2} justifyContent="space-between" alignItems="center">
          <Flex direction="column" alignItems="flex-start" gap={2}>
            <H3>
              <FormattedMessage id="wallet.reward.admin.subscriptionBanner.title" />
            </H3>
            <Body>
              <FormattedMessage id="wallet.reward.admin.subscriptionBanner.info" />
            </Body>
            <Button
              small
              onClick={() => {
                tracking.clickSubscriptionBanner(trackingSource)
                setModalState("subscribe")
              }}>
              <FormattedMessage id="wallet.reward.admin.subscriptionBanner.cta" />
            </Button>
          </Flex>
          <Circle>
            <Icon />
          </Circle>
        </Flex>
      </Card>
      <SubscribeModal isShown={modalState === "subscribe"} onHide={() => setModalState("none")} onComplete={() => setModalState("complete")} />
      <ConfirmationModal isShown={modalState === "complete"} onHide={() => setModalState("none")} onComplete={() => setModalState("none")} />
    </>
  )
}

export default injectIntl(SubscriptionBanner)
